import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function logotypeIconsSilder() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const blocks = document.querySelectorAll('.externalIconsArray .externalIconsSlider.default');
        const blocksTransform = document.querySelectorAll('.externalIconsArray .externalIconsSlider.transform');
        window.addEventListener('resize', function () {
            initSwiper();
            initSwiperTransform();
        });

        initSwiper();
        
        function initSwiper() {
            blocks.forEach(block=>{
                let smallIcon = new Splide(block, {
                type  : 'loop',
                rewind: true,
                autoplay: true,   
                perPage: 8,
                gap: 0,
                perMove: 1,
                pagination:false,
                arrows: false,
                interval: 0,
                speed: 8000,
                breakpoints: {
                    768: {
                        perPage: 2,
                    },
                    1024: {
                        perPage: 4,
                    },
                    1440: {
                        perPage: 8,
                    },
                    1920: {
                        perPage: 10,
                    }
                },          
                });
                smallIcon.mount();
            });
        }

        initSwiperTransform();
        
        function initSwiperTransform() {
            blocksTransform.forEach(block=>{
                let smallIconTransform = new Splide(block, {
                type  : 'loop',
                rewind: true,
                autoplay: true,   
                perPage: 4,
                gap: 0,
                perMove: 1,
                pagination:false,
                arrows: false,
                focus    : 'center',
                interval: 0,
                speed: 8000,
                breakpoints: {
                    768: {
                        perPage: 2,
                    },
                },          
                });
                smallIconTransform.mount();
            });
        }
    })
}